import React from 'react'

interface GalleryTileProps {
  children: React.ReactNode
  badge?: React.ReactNode
  onClick?: () => void
}

const GalleryTile: React.FC<GalleryTileProps> = ({ children, badge, onClick }) => {
  return (
    <div
      className="ratio ratio-1x1 bg-dark rounded overflow-hidden position-relative"
      onClick={onClick}
    >
      {badge && <div className="position-absolute top-0 end-0 m-2">{badge}</div>}
      <div className="position-absolute top-0 bottom-0 start-0 end-0">{children}</div>
    </div>
  )
}

export default GalleryTile
